import React from 'react';

import { Skeleton } from '@dashboard/components/ui/skeleton';

const Card = ({ chart = false }) => (
  <div className="flex flex-col gap-y-1 rounded border border-gray-200 dark:border-border bg-white dark:bg-background p-4">
    <Skeleton className="mb-2 h-4 w-4" />
    <Skeleton className="h-4 w-24" />
    <Skeleton className="mt-1 h-6 w-16" />
    {chart && <Skeleton className="mt-3 h-20 w-full" />}
  </div>
);

/** Summary's loading state: the page's title card, the chart cards, then the smaller cards. */
export default function SummarySkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading" className="space-y-4">
      <div className="flex h-9 items-center">
        <Skeleton className="h-6 w-24" />
      </div>
      <div className="grid gap-2">
        <div className="space-y-2 rounded border border-gray-200 dark:border-border p-4">
          <Skeleton className="h-6 w-56" />
          <Skeleton className="h-4 w-24" />
        </div>
        <div className="grid gap-2 md:grid-cols-2 xl:grid-cols-3">
          <Card chart />
          <Card chart />
          <Card chart />
        </div>
        <div className="grid gap-2 md:grid-cols-2 xl:grid-cols-3">
          <Card />
          <Card />
          <Card />
        </div>
      </div>
    </div>
  );
}

/** The page sidebar's place while the page loads, so the content does not shift when it arrives. */
export function SummarySidebarSkeleton() {
  return (
    <div>
      <div className="flex h-14 items-center">
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="mt-[13px]">
        {[0, 1, 2, 3, 4, 5, 6, 7].map(index => (
          <div key={index} className="flex h-9 items-center gap-2">
            <Skeleton className="size-4" />
            <Skeleton className="h-4 w-24" />
          </div>
        ))}
      </div>
    </div>
  );
}
